import { render, staticRenderFns } from "./PatientListModal.vue?vue&type=template&id=2687cad4&scoped=true&"
import script from "./PatientListModal.vue?vue&type=script&lang=js&"
export * from "./PatientListModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientListModal.vue?vue&type=style&index=0&id=2687cad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687cad4",
  null
  
)

export default component.exports